import React from "react";
import { CircularProgress } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import "../style/spinner.scss";
import { useTheme } from "@mui/material/styles";

function LoadingSpinner({ role }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const isOnet = role === "onet";
  const isCompass = role === "compass";
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50vh",
      }}
    >
      <ThemeProvider theme={theme}>
        <div className="logo-spinner-container">
        <CircularProgress
            size={80}
            thickness={2}
            sx={{
              color: isOnet ? '#06305C' :  isCompass ? "#c4ac66" :  'primary.main',
            }}
          />
            <img
            src={isOnet ?  isDark ? "/assets/logo-onet-blanc.png" :
              "/assets/Logo_Onet.svg.png" : isCompass ? isDark ? "assets/CPG.L_BIG.D.png" : "assets/CPG.L_BIG.png" : "/assets/logoNM.png"}
            alt={isOnet ? "logo Onet" : isCompass ? "logo compass" : "logo nouvelle marque"}
            className="logo-spinner-logo"
          />
        </div>
      </ThemeProvider>
    </div>
  );
}

export default LoadingSpinner;
